<template>
	<div>
		<el-dialog :visible.sync="showmodal" title="Update Status" width="30%" @close="$emit('close-modal')">
			<div class="particulars-img-wrapper">
				<div class="container-fluid">
					<div class="row">
						<div class="col-md-12 col-lg-12 col-12">
							<label for="" class="label">Current Status</label>
							<input type="text" disabled v-model="capStatus" class="input" />
						</div>
						<div class="col-md-12 col-lg-12 col-12">
							<label for="" class="label">Updated By</label>
							<input type="text" disabled v-model="updatedBy" class="input" />
						</div>
						<div class="col-md-12 col-lg-12 col-12">
							<label for="" class="label">Date Last Updated</label>
							<el-date-picker type="date" placeholder="Start Date" style="margin: 0" class="mr-3"
							v-model="booking.updatedAt" />
						</div>
						<div class="col-md-12 col-lg-12 col-12">
							<label for="" class="label">New status</label>
							<el-select v-model="statusobj.newstatus" placeholder="Select state">
								<el-option v-for="status in statuses" :key="status" :label="capitalize(status)" :value="status">
								</el-option>
							</el-select>
						</div>
					</div>
				</div>
			</div>

			<div class="button-wrapper">
				<button @click="$emit('close-modal')">Cancel</button>
				<base-button text="Update" :loading="loading" @click="updateStatus" />
			</div>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
export default {
	props : {
		showmodal : Boolean,
		booking : Object,
		currentStatus : String,
		lastUpdated : String
	},
	data() {
		return {
			statusobj : this.getform(),
			loading : false,
			updatedBy : this.$store.getters.user.firstname + " " + this.$store.getters.user.lastname,
			statuses : [
				"processing",
				"assigned",
				"un_assigned",
				"pending",
				"accepted",
				"picked_up",
				"completed",
				"active",
				"dropped_off",
				"delayed",
				"in_transit",
				"arrived",
				"on_delivery",
				"delivered",
				"delivery_confirmed",
				"dispatched",
				"canceled",
				"pickup_canceled",
				"declined",
				"delayed",
				"dispatched_to_consignee",
				"closed",
				"scheduled",
				"draft"
			]

		}
	},
	methods : {
		getform(){
			return {
				newstatus : "",
				message : "",
			}
		},
		async updateStatus(){
			
			let request = {
				deliveryStatus : this.statusobj.newstatus,
				message : "Status Updated to " + this.statusobj.newstatus,
				userId : this.$store.state.authentication.userId
			}

			try{
				this.loading = true

				await this.$_updateShippingStatusByDriver(this.booking.id, request)
				this.loading = false 
				this.$emit('booking-subaction-completed')
				this.$emit('refetchBooking')
				this.$emit('close-modal')
			}catch(error){
				this.loading = false;
				this.handleError(error);
			}
			
		},
		capitalize(str){
            let capitalizedstr = str.charAt(0).toUpperCase() + str.slice(1)

            return capitalizedstr
        },
	},
	computed : {
		capStatus() {
			return this.capitalize(this.booking.deliveryStatus)
		}
	}
}
</script>